<script setup>
import { ref, watch } from 'vue'
import { Form as AForm, FormItem as AFormItem, Input, Button as AButton } from 'ant-design-vue'

const AInputPassword = Input.Password

import { setSessionStorage } from '@/utils'

const props = defineProps({
  value: { type: String, default: '' },
  pwdError: { type: Boolean, default: true },
  queryFun: { type: Function, default: () => {} }
})

const getRules = () => {
  return {
    pwd: [{ required: true, message: '請輸入密碼' }]
  }
}

const formRef = ref()
const validateFailed = ref(props.pwdError ? { pwd: true } : {})

const formData = ref({})
const rules = ref(getRules())

watch(
  () => formData.value,
  () => {
    rules.value = getRules()
    validateFailed.value = {}
  },
  {
    deep: true
  }
)

const submitHandler = () => {
  formRef.value.validate().then(() => {
    setSessionStorage(props.value, formData.value.pwd)
    props.queryFun()
  })
}
</script>

<template>
  <div class="tvb-preview-login">
    <div class="tvb-preview-login_wrap">
      <p class="tvb-preview-login_header-title">分享已加密，請輸入密碼查看網頁</p>
      <div class="login-form">
        <a-form
          ref="formRef"
          :model="formData"
          @finish="submitHandler"
          :rules="rules"
          hide-required-mark
        >
          <a-form-item
            name="pwd"
            v-bind="{
              ...(validateFailed.pwd && {
                validateStatus: 'error',
                help: '請輸入正确密碼'
              })
            }"
            style="width: 140px; margin: auto"
          >
            <a-input-password
              v-model:value="formData.pwd"
              placeholder="請輸入密碼"
              :visibility-toggle="true"
            />
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
              class="inline-flex justify-center py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm w-px-4 hover:bg-indigo-700 focus:outline-none form-submit"
              >確定</a-button
            >
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tvb-preview-login {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .tvb-preview-login_header-icon {
    height: 200px;
    width: 300px;
  }

  .tvb-preview-login_header-title {
    color: #1e1e1e;
    font-size: 28px;
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 34px;
  }

  .tvb-preview-login_description {
    color: #818d95;
    font-size: 16px;
    letter-spacing: 0.5px;
    line-height: 22px;
    margin-top: 4px;
  }

  :deep(.tvb-button) {
    width: 131px;
    box-sizing: border-box;
    background-color: #0062a3;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #555555;
    backdrop-filter: none;
    border-radius: 6px;
    color: rgba(255, 255, 255, 0.9);
    --tvb-button-height: 40px;
    margin-top: 24px;
    overflow: hidden;
    > .span {
      --tvb-button-padding: 0 16px 0 18px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.icon {
      .svg-icon {
        font-size: 12px;
        opacity: 0.85;
        margin-left: 2px;
      }
    }
  }

  &.empty-s,
  &.empty-xs {
    .tvb-preview-login_header-icon {
      height: 120px;
      width: 180px;
    }
    .tvb-preview-login_header-title {
      font-size: 18px;
      line-height: 24px;
    }
    .tvb-preview-login_description {
      letter-spacing: 0px;
      font-size: 14px;
      line-height: 20px;
      margin-top: 2px;
    }
    :deep(.tvb-button) {
      width: 108px;
      font-size: 14px;
      letter-spacing: 0.3px;
      --tvb-button-height: 32px;
      margin-top: 12px;
      > .span {
        --tvb-button-padding: 0 11px 0 14px;
      }
      &.icon {
        .svg-icon {
          font-size: 10px;
          margin-left: 1px;
        }
      }
    }
  }
}

.login-form {
  margin-top: 24px;

  & :global(input) {
    color: #1e1e1e;
    font-family: 'PingFang HK';
    font-size: 16px;
    letter-spacing: 0.1px;
    line-height: 40px;
    align-items: center;
    border: 1px solid rgba(30, 30, 30, 0.3);
    border-radius: 4px;
    padding: 0px 16px;
  }

  & :global(.ant-input-affix-wrapper) {
    font-size: 16px;
    border-radius: 5px;
  }
}

.form-submit {
  height: 40px;
  min-height: 30px;
  width: 161px;
  border-radius: 6px;
  background-color: #0062a3;
  border-color: #0062a3;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
}
</style>
